var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGgrWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_122_797)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07704 12.5234C3.47227 15.3091 5.90417 17.1128 8.9657 17.2859C6.25059 17.384 4.13914 16.6489 3.55218 15.1809L3.52921 15.1242C3.03302 16.0498 2.91091 16.9281 3.25315 17.6566C4.26662 19.8137 8.96814 19.8402 13.7543 17.7157C15.9767 16.7293 17.8265 15.4526 19.0692 14.1518C18.4162 13.6275 18 12.8343 18 11.9468C18 10.3679 19.3169 9.08789 20.9413 9.08789C20.9505 9.08789 20.9597 9.08793 20.9688 9.08801C19.7236 5.54654 16.2702 3 12.2048 3C9.01366 3 6.19956 4.56906 4.53456 6.95675C3.40025 8.90375 2.78586 10.4711 3.07704 12.5234ZM21.0057 14.805C20.9843 14.8054 20.9628 14.8056 20.9413 14.8056C20.5172 14.8056 20.114 14.7184 19.7498 14.5613C18.2007 16.3697 15.9435 18.1486 13.248 19.345C11.8903 19.9477 10.6036 20.3437 9.4029 20.5806C10.2868 20.853 11.2281 21 12.2048 21C16.311 21 19.793 18.402 21.0057 14.805ZM14.5192 16.1089C13.6821 16.4251 12.8472 16.6764 12.0325 16.8648C9.24706 16.864 6.9893 14.6672 6.9893 11.9573C6.9893 9.31882 9.12969 7.16666 11.8135 7.05441L11.8146 7.04958C13.866 6.99332 15.2897 7.19948 15.8252 7.31238V9.02024C15.1617 8.87086 13.2151 8.67448 11.849 8.74646L11.8491 8.74927C10.1125 8.83485 8.73149 10.2317 8.73149 11.9424C8.73149 13.7082 10.203 15.1397 12.0181 15.1397L12.0206 15.1397V15.138C13.2083 15.138 13.9927 15.0713 14.5022 14.9944V12.7216L16.2471 12.235L16.2471 15.3469C16.4036 15.2717 16.5585 15.1951 16.7115 15.1172C16.0169 15.486 15.2821 15.8207 14.5192 16.1089Z",
    fill: "#EEF9FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_797",
    x: 2.00513,
    y: 2.5,
    width: 20.0005,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_797",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGgrWhite);
export default __webpack_public_path__ + "static/media/icon-ggr-white.dba71851a80dfcca9474dff433ed61b1.svg";
export { ForwardRef as ReactComponent };